import { Routes } from '@angular/router';

export const preferencesRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./preferences.page').then((m) => m.PreferencesPage),
  },
];
